import React from 'react'

// eslint-disable-next-line jsx-a11y/alt-text
export const Image = (props) => <img {...props} />
